<template>
    <form @submit.prevent="$emit('next')" class="step-form">
      <div class="date-fields">
        <div class="form-group">
          <label for="arrival">Date d'arrivée</label>
          <input v-model="value.arrival" id="arrival" type="date" />
        </div>
        <div class="form-group">
          <label for="departure">Date de départ</label>
          <input v-model="value.departure" id="departure" type="date" />
        </div>
      </div>
  
      <div class="form-group checkbox-group">
        <input type="checkbox" id="flexible" v-model="value.flexible" />
        <label for="flexible" class="font-weight-100">Dates flexibles</label>
      </div>
  
      <div class="form-group">
        <label for="participants">Nombre de participants estimé</label>
        <input v-model="value.participants" id="participants" type="number" min="1" />
      </div>
  
      <div class="form-group">
        <label for="location">Lieu souhaité</label>
        <input v-model="value.location" id="location" type="text" />
      </div>

      <div class="form-group">
        <label for="budget">Budget HT (hors transport)</label>
        <input v-model="value.budget_ht" id="budget" type="text" />
      </div>
  
      <div class="form-group">
        <label>Type d’événement</label>
        <div class="checkbox-grid ml-7 my-3">
          <div v-for="type in eventTypes" :key="type">
            <input type="checkbox" :id="type" :value="type" v-model="value.eventTypes" />
            <label class="font-weight-100" :for="type">{{ type }}</label>
          </div>
        </div>
        <input v-model="value.otherEventType" type="text" placeholder="Autre (champs libre)" class="other-input extra" />
      </div>
  
      <div class="form-group">
        <label>Besoins spécifiques</label>
        <div class="checkbox-grid my-3">
          <div v-for="need in specificNeeds" :key="need">
            <input type="checkbox" :id="need" :value="need" v-model="value.specificNeeds" />
            <label class="font-weight-100" :for="need">{{ need }}</label>
          </div>
        </div>
        <input v-model="value.otherNeeds" type="text" placeholder="Autre (champs libre)" class="other-input extra" />
      </div>
  
      <div class="button-group">
        <button class="px-5" type="submit">Suivant</button>
      </div>
    </form>
  </template>
  
  <script>
  export default {
    name: 'StepTwo',
    props: {
      value: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        eventTypes: [
          'Séminaire',
          'Workation',
          'Formation',
          'Team-building',
          'Conférence',
          'Comité de direction'
        ],
        specificNeeds: [
          'Salles de séminaire / Réunion',
          'Matériel ( vidéoprojecteur, paperboard, sonorisation… )',
          'Restauration ( repas assis, buffet, cocktail, etc. )',
          'Activités ( team-building, détente, sport, nature, etc. )',
          'Conférenciers / intervenants externes',
          'Animation de temps collectifs'
        ]
      }
    }
  }
  </script>
  
  <style scoped>
  #arrival{
    width: 18rem;
    @media(max-width: 480px){
        width: 100%;
    }
  }
  #departure{
    width: 18rem;
    @media(max-width: 480px){
        width: 100%;
    }
  }
  .step-form {
    display: flex;
    flex-direction: column;
    gap: 0.9rem;

  }
  .date-fields {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    @media(max-width: 480px){
     flex-direction: column;   
    }
  }
  .form-group label {
    font-weight: 500;
    display: block;
    margin-bottom: 0.25rem;
  }
  .form-group input[type="text"],
  .form-group input[type="number"],
  .form-group input[type="date"],
  .other-input {
    width: 100%;
    padding: 0.6rem;
    border: 1px solid #4a6c5e;
  }
  .checkbox-group,
  .checkbox-grid {
    display: grid;
    gap: 0.5rem;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  }
  .button-group {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  }
  button {
    padding: 0.75rem 1.5rem;
    background-color: #345b48;
    color: white;
    border: none;
    cursor: pointer;
  }
  input[type="checkbox"] + label::before{
    border: 1px solid #3B6152;
    border-radius: 0px;
  }
  .extra{
    border-left: 0px  !important;
    border-right: 0px  !important;
    border-top: 0px  !important;
  }
  .font-weight-100{
    font-weight: 100 !important;
  }
  .ml-7{
    margin-left: 7rem !important;
    @media(max-width: 480px){
        margin-left: 0px !important;
    }
  }
  .form-group input:focus {
    border: 2px solid #4a6c5e; 
    outline: none;
  }
  </style>